import { Parse } from '@/store/parseUtils'
import type { Study } from '@pocketprep/types'
import { fetchLoadable } from '@/store/utils'
import { examMetadataModule } from '@/store/examMetadata/module'
import { bundleModule } from '@/store/bundle/module'
import * as Sentry from '@sentry/vue'

const fetchExamMetadata = async () => {
    const examLoadable = examMetadataModule.state.examMetadata

    /**
     * This is required for server-nest migrations, since server-nest includes exams.
     * @todo This will be refactored once server-nest is fully migrated.
     */
    const bundles = await bundleModule.actions.fetchBundles()
    if (bundles?.exams) {
        examMetadataModule.state.examMetadata.value =
            bundles.exams
    } else {
        if (import.meta.env.VUE_APP_NEST_API_URL_DOMAIN) {
            const error = new Error('Server-nest migration: No exams found in bundles')
            Sentry.captureException(error)
        }
        await fetchLoadable(examLoadable, async () => {
            const examMetadata = await new Parse.Query<Study.Class.ExamMetadata>('ExamMetadata')
                .findAll({ batchSize: 500 })
            return examMetadata.map(e => e.toJSON())
        })
    }
}

export default {
    fetchExamMetadata,
}
